export default "__VITE_ASSET__D82abf0l__"